import { CONTENT_REDUCER_KEY } from '@glass/web/modules/content/reducer';

// todo: create state type
const selectResumeBuilderBasePath = (state: {
  [x: string]: { resumeBuilderBasePath: string | null | undefined };
}) => state[CONTENT_REDUCER_KEY]?.resumeBuilderBasePath;

export default selectResumeBuilderBasePath;
